import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { formatCurrency } from 'libs/uikit/src/shared/formatters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceComparisonPolicyCompareFooterInfoView = function PriceComparisonPolicyCompareFooterInfoView(props) {
  var _info$jove_quote_pric, _info$jove_quote_pric2, _info$jove_quote_pric3, _info$jove_quote_pric4, _info$jove_quote_pric5;

  var className = props.className,
      info = props.info;

  var _useState = useState(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  return !!(info !== null && info !== void 0 && (_info$jove_quote_pric = info.jove_quote_price) !== null && _info$jove_quote_pric !== void 0 && (_info$jove_quote_pric2 = _info$jove_quote_pric.aggregate_prices) !== null && _info$jove_quote_pric2 !== void 0 && _info$jove_quote_pric2.jove_commission_discount_amount) ? /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex cursor-pointer flex-row items-center justify-center space-x-2 rounded-bl-xl rounded-br-xl px-4 pb-3 pt-1 transition-all duration-300', 'from-[#4096DF]/8 to-[#2E5DB8]/8 bg-gradient-to-r', isHovered && 'scale-102 from-[#4096DF]/12 to-[#2E5DB8]/12 shadow-lg', className),
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    children: [/*#__PURE__*/_jsx("style", {
      children: "\n          @keyframes slideInUp {\n            from {\n              opacity: 0;\n              transform: translateY(20px);\n            }\n            to {\n              opacity: 1;\n              transform: translateY(0);\n            }\n          }\n          @keyframes pulse-scale {\n            0%, 100% {\n              transform: scale(1);\n            }\n            50% {\n              transform: scale(1.15);\n            }\n          }\n          @keyframes float {\n            0%, 100% {\n              transform: translateY(0px);\n            }\n            50% {\n              transform: translateY(-3px);\n            }\n          }\n          .discount-footer {\n            animation: slideInUp 0.6s ease-out forwards;\n          }\n          .discount-icon {\n            animation: pulse-scale 2s ease-in-out infinite;\n            display: inline-block;\n            font-size: 24px;\n          }\n          .discount-amount {\n            animation: float 1.5s ease-in-out infinite;\n          }\n        "
    }), /*#__PURE__*/_jsx("div", {
      className: "discount-footer",
      children: /*#__PURE__*/_jsx("span", {
        className: "discount-icon",
        children: "\uD83D\uDC49"
      })
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "subtitle1",
      className: "font-bold leading-5 text-[#202020]",
      children: ["Choose Jove, and we have given you a special discounted price of", ' ', /*#__PURE__*/_jsx("span", {
        className: "discount-amount inline-block text-lg font-bold text-[#0E35D1]",
        children: formatCurrency({
          amount: info === null || info === void 0 ? void 0 : (_info$jove_quote_pric3 = info.jove_quote_price) === null || _info$jove_quote_pric3 === void 0 ? void 0 : (_info$jove_quote_pric4 = _info$jove_quote_pric3.aggregate_prices) === null || _info$jove_quote_pric4 === void 0 ? void 0 : _info$jove_quote_pric4.jove_commission_discount_amount,
          currency: info === null || info === void 0 ? void 0 : (_info$jove_quote_pric5 = info.jove_quote_price) === null || _info$jove_quote_pric5 === void 0 ? void 0 : _info$jove_quote_pric5.currency
        })
      })]
    })]
  }) : null;
};

export default PriceComparisonPolicyCompareFooterInfoView;